module.exports = __webpack_public_path__ + "screen_interactions-9837dafaee30c5efee219d469acd1e84.svg";